// services/emailVerificationGate.ts

/**
 * The backend refuses turning on two-factor authentication and adding a
 * passkey until the account's email is verified: 403 `EMAIL_NOT_VERIFIED`
 * (ORA-1089). The Security tab says so and offers the verification email.
 */
export const EMAIL_NOT_VERIFIED_CODE = 'EMAIL_NOT_VERIFIED';

export const EMAIL_NOT_VERIFIED_MESSAGE = 'Verify your email first.';

export const isEmailNotVerified = (
  error: { code?: string } | null | undefined
): boolean => error?.code === EMAIL_NOT_VERIFIED_CODE;
